import AddIcon from '@mui/icons-material/Add'
import { Box, Button } from '@mui/material'
import { useState } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'
import ToggleContainer from '../../../components/Containers/ToggleContainer'
import { useOrderFormContext } from '../context/OrderFormContext'
import { useOrderStatus } from '../hooks/useOrderStatus'
import FlowSection from './FlowSection'
import messages from './messages'
import TransitDetailsForm from './TransitDetailsForm'
import TransportIcon from './TransportIcon'
import WaypointForm from './WaypointForm'

interface WaypointContainerProps {
  consignmentIndex: number
  disabled?: boolean
}

const WaypointContainer: React.FC<WaypointContainerProps> = ({
  consignmentIndex,
  disabled = false,
}: WaypointContainerProps) => {

  const { control, watch } = useFormContext()
  const [isOpenTransitDetails, setIsOpenTransitDetails] = useState(true)
  const { formatMessage } = useIntl()
  const { isCreated } = useOrderStatus()

  const handleToggleTransitDetail = () => {
    setIsOpenTransitDetails((prev) => !prev)
  }

  const { variant } = useOrderFormContext()

  const { insert, fields, remove, append } = useFieldArray({
    control,
    name: `bookings.${consignmentIndex}.waypoints`,
  })

  const transitDetailMode = watch(
    `bookings.${consignmentIndex}.shipFrom.transitDetails.modeOfTransit`
  )

  return (
    <>
      <FlowSection icon={<TransportIcon id={transitDetailMode} />} showIcon={isOpenTransitDetails}>
        <Box sx={{ p: `${!isOpenTransitDetails ? 0 : variant === 'summary' ? '8px 0 0 24px' : (disabled || isCreated) ? '10px 0 16px 24px' : '10px 0 0 24px'}` }}>
          <ToggleContainer
            title={formatMessage(messages.transitDetails)}
            isOpen={isOpenTransitDetails}
            handleToggle={handleToggleTransitDetail}
            isGrey={true}
            sx={variant === 'summary' ? { pb: '8px', mb: '16px' } : {}}
          >
            <TransitDetailsForm
              namePrefix={`bookings.${consignmentIndex}.shipFrom.transitDetails`}
              disabled={disabled}
              consignmentIndex={consignmentIndex}
            />
          </ToggleContainer>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Box>
              {!isOpenTransitDetails && (
                <Button onClick={handleToggleTransitDetail} sx={{ textTransform: 'none' }}>
                  {formatMessage(messages.showTransitDetails)}
                </Button>
              )}
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Box display="flex" justifyContent="flex-end" >
            {(!disabled && !isCreated) && (
              <Button
                startIcon={<AddIcon />}
                onClick={() => {
                  append({
                    transitDetails: {
                      carrierOption: 'noPreference',
                    },
                  })
                }}
                sx={{ textTransform: 'none' }}
              >
                {formatMessage(messages.addWaypoint)}
              </Button>
            )}
          </Box>
        </Box>
      </FlowSection>
      {fields.map((field, waypointIndex) => (
        <WaypointForm
          key={field.id}
          consignmentIndex={consignmentIndex}
          waypointIndex={waypointIndex}
          removeWaypoint={remove}
          insertWaypoint={insert}
          disabled={disabled}
        />
      ))}
    </>
  )
}

export default WaypointContainer
